/* import __COLOCATED_TEMPLATE__ from './dac-svg-panel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();